import { productDetailData, productDwonloads, productFaqBySpuId } from '@/service/product';

/**
 * 产品详情页中获取support的所有数据
 * @param getProductMsg
 * @param locale
 * @param productMsg
 * @returns
 */
export async function getProductData(promsg: any, locale: string | undefined, spuId?: string) {
    try {
        const [detailRes, faqRes, downloadsRes, videosRes, onlinesRes] = await Promise.all([
            productDetailData({ handle: promsg.url }, locale || 'us'),
            productFaqBySpuId({ spuId: promsg.sourceId }, locale || 'us'),
            productDwonloads({ spuIds: promsg.sourceId }, locale || 'us'),
            productDwonloads({ spuIds: promsg.sourceId, classify: 'VIDEO_COURSE' }, locale || 'us'),
            productDwonloads({ spuIds: promsg.sourceId, classify: 'ONLINE' }, locale || 'us'),
        ]);

        const data1 = detailRes.data || {};
        const data2 = faqRes.data?.records || [];
        const data3 = downloadsRes?.data?.content || [];
        const data4 = videosRes?.data?.content || [];
        const data5 = onlinesRes?.data?.content || [];

        return {
            productCatagory: data1.productCatagoryResponseList,
            productDetail: data1.spuResponse,
            supportData: {
                faqList: data2,
                downloadList: data3,
                videoList: data4,
                onlineList: data5,
            },
            spuId: promsg?.spuId || promsg?.sourceId,
        };
    } catch (error) {
        console.error(error);
    }

    return {
        productCatagory: [],
        productDetail: {},
        supportData: {
            faqList: [],
            downloadList: [],
            videoList: [],
            onlineList: [],
        },
        spuId: null,
    };
}
